// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.citation-card:hover {
  background-color: #f2f3f3;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.citation-card:active {
  background-color: #e9ebed;
  box-shadow: none;
  transform: scale(0.99);
}

.citation-card:focus-visible {
  outline: 2px solid #0972d3;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CitationPanel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".citation-card:hover {\n  background-color: #f2f3f3;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.citation-card:active {\n  background-color: #e9ebed;\n  box-shadow: none;\n  transform: scale(0.99);\n}\n\n.citation-card:focus-visible {\n  outline: 2px solid #0972d3;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
